module.exports = __webpack_public_path__ + "img/opera-paris.9783b4f5.jpg";